<script>
import SendHistContent from'../contents/SendHistContent.vue';
export default {
    data: function () {
        return{
            /**
             * 遷移先の画面名を格納
             */
            path : 'login',
            loginErrorStatus :'401',

        }
    },
    methods: {
        /**
         * 401エラーの場合は、ログイン画面に戻す
         *
         * 引数
         * error：axiosError
         * router：画面遷移用のクラス（画面側ではおそらくこれ⇒router）
         * route：現在のpathやqueryなどが格納されているクラス（画面側ではおそらくこれ⇒route）
         */
        authorityError(error,router,route){
            //router = useRouter();
            //router = router;
            //route = route;
            if(error.response.status == 401){
                //ログアウト処理
                //const router = useRouter();
                //遷移先では、セッションパラメータエラーを伝える
                sessionStorage.clear();
                sessionStorage.setItem('sessionTimeOut', true);
                console.log(route);
                this.backToLogin(router,route)
                //routerを読み込めないため、各画面のエラー処理側でエラーを処理する
                //router.push({name: 'login'});
            }
        },
        /**
         * ログイントークンに誤りがある時の処理
         * login画面に戻し、このコンポーネントの呼出し元の画面にリダイレクトする
         * 
         * 引数
         * 以下は、この画面で宣言できないため、引数で受け取る
         * router:ルートを行う
         * route:前画面のルート処理の詳細が入っている
         */
        backToLogin(router,route){
            var routepath = null;

            console.log(route);
            console.log(router);

            routepath = route.fullPath != null ? route.fullPath : null;
            console.log(routepath);
            if(routepath){
                // login画面に戻し、このコンポーネントの呼出し元の画面にリダイレクトする
                router.push({name : 'login', query :{redirect : routepath}});
            }else{
                router.push({name : 'login'});
            }

        },

        /**
         * 権限チェック
         */
        checkAuthority(sendHistAddCd){
            var loginParm = sessionStorage.getItem('loginParm');
            if(loginParm.Authority== SendHistContent.administrator){
                return true
            } else if(loginParm.Authority == SendHistContent.sender){
                //配信者のusercodeとログインユーザーのusercodeを比較
                //成立した場合のみtrueとする
                return sendHistAddCd == loginParm.Username? true:false

            }else{
                return false
            }
        }
    },
}
</script>
